<template>
    <div>
        <div>
            <b-nav tabs>
                <b-nav-item router-link to="/hr/import-work-time">
                    <icon name="users"></icon>
                    นำเข้าเวลาการทำงาน
                </b-nav-item>&nbsp
                <b-nav-item router-link to="/hr/import-ot-hour">
                    <icon name="users"></icon>
                    นำเข้าชม OT
                </b-nav-item>&nbsp
                <b-nav-item router-link to="/hr/import-ot-hour-double">
                    <icon name="users"></icon>
                    นำเข้าชม OT *2
                </b-nav-item>&nbsp
            </b-nav>
        </div>
        <div class="container-fluid" style="background-color: white">
            <router-view />
        </div>
    </div>
</template>

<script>
    export default {
        name: "ImportWorkTimeEmployeeLayout"
    }
</script>

<style scoped>

</style>
